import {
  EVENT_SCORES_REQUEST,
  EVENT_SCORES_SUCCESS,
  EVENT_SCORES_FAILURE,
  LIVE_SCORES_WS_UPDATE,
  MATCH_CARD_SCORE_UPDATE
} from 'Store/constants';

import merge from 'lodash/merge';

const initialState = {
  data: { },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EVENT_SCORES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case EVENT_SCORES_SUCCESS: {
      
      const eventScoresList = action.payload.reduce((allData, currentData) => {
        // eslint-disable-next-line no-nested-ternary
        const normalizedScores = Array.isArray(currentData.scores?.[0])
          ? currentData.scores[0]
          : Array.isArray(currentData.scores)
            ? currentData.scores
            : [];
        const tempEventScores = {
          [currentData['sbsEventId']]: {
            currentScore: currentData.currentScore || {},
            scores: normalizedScores,
            overTime: currentData.overTime?.home ? currentData.overTime : null,
            penalty: currentData.penalty?.home ? currentData.penalty : null,
            matchStatus: currentData?.matchStatus,
            sportType: currentData?.sportType
          } };
        return { ...allData, ...tempEventScores };
      }, {});

      const newEventScoresList = { ...state.data, ...eventScoresList };
      return {
        ...state,
        data: newEventScoresList,
        isLoading: false,
        error: null
      };
    }

    case MATCH_CARD_SCORE_UPDATE: {
      const { eventId, score, currentGameTime, eventStatusId } = action.payload;
      const currentScore = score?.length ? score[score.length - 1] : {};
      merge(state.data, {
        [eventId]: {
          ...state.data[eventId],
          currentScore: {
            ...state.data[eventId]?.currentScore,
            currentPeriodAway: currentScore.currentPeriodAway,
            currentPeriodHome: currentScore.currentPeriodHome,
            home: currentScore.homeScore,
            away: currentScore.awayScore,
            time: currentGameTime
          },
          matchStatus: eventStatusId
        } });

      return {
        ...state,
        data: state.data,
        isLoading: false,
        error: null
      };
    }

    case LIVE_SCORES_WS_UPDATE: {
      const { payload: { value }  } = action;

      return {
        ...state,
        data: {
          ...state.data,
          [value['sbsEventId']]: {
            ...state.data[value['sbsEventId']],
            matchStatus: value.matchStatus,
            currentScore: {
              home: value.home,
              away: value.away,
              title: value.title,
              type: value['periodType'],
              time: value.time,
              currentPeriodAway: value.currentPeriodAway,
              currentPeriodHome: value.currentPeriodHome,
            }
          }
        },
        isLoading: false,
        error: null
      };
    }

    case EVENT_SCORES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
